import ZipInCardStateEnum from '../../enums/ZipInCardStateEnum.js';
import ZipInStepEnum from './ZipInStepEnum.js';
const ZipInDefaultState = {
    step: ZipInStepEnum.default,
    zipCode: '',
    zipInCardState: ZipInCardStateEnum.default,
    assemblyServicesData: null,
    zipAvailabilities: null
};
export default ZipInDefaultState;
//# sourceMappingURL=ZipInDefaultState.js.map